// extracted by mini-css-extract-plugin
module.exports = {"homeCard":"home_homeCard__3bhuv","homeCardTitle":"home_homeCardTitle__7OAmP","buttonHome":"home_buttonHome__cmoc3","gridContainer":"home_gridContainer___eJfH"};